function addAltProductImage(){
  $('.product-listing .product-item .image .hover-image').each(function() {
    const $this = $(this);
    const dataStyle = $this.data('style');
    $this.attr('style', dataStyle);
  })
}

export default addAltProductImage();



// WEBPACK FOOTER //
// ../markup/assets/js/product-alt-image.js